import { auth } from '@dashai/lib/firebase';

/**
 * Fire-and-forget user-action tracking. Writes a row to `login_events`
 * via `dashaiAdminTrackLogin` on Firebase. The endpoint validates `eventType`
 * against an allowlist (`ALLOWED` in admin/dashboard/events.ts) and rejects
 * unknown values with 400 — a new frontend event type must be added there too.
 *
 * Never throws — tracking must never block the UI.
 */
export async function trackUserAction(params: {
  eventType: string;
  metadata?: Record<string, unknown>;
  idClient?: string;
}): Promise<void> {
  try {
    const idToken = await auth.currentUser?.getIdToken();
    if (!idToken) return;

    const fbBase = import.meta.env.VITE_FIREBASE_FUNCTIONS_URL as string | undefined;
    if (!fbBase) {
      console.error(
        '[trackUserAction] VITE_FIREBASE_FUNCTIONS_URL is not set — cannot reach dashaiAdminTrackLogin.',
      );
      return;
    }
    await fetch(`${fbBase.replace(/\/+$/, '')}/dashaiAdminTrackLogin`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${idToken}`, 'Content-Type': 'application/json' },
      body: JSON.stringify({
        eventType: params.eventType,
        idClient: params.idClient,
        metadata: params.metadata,
      }),
    });
  } catch {
    // Silent fail — tracking should never block the user
  }
}
